import auth from './de-DE/auth.json';
import emailValidationPage from './de-DE/emailValidationPage.json';
import links from './de-DE/links.json';
import remoteActivation from './de-DE/remoteActivation.json';
import site from './de-DE/site.json';
import tags from './de-DE/tags.json';

export default { auth, emailValidationPage, links, remoteActivation, site, tags };
